import Page from "../components/Page";
import ReviewsSection, { REVIEWS_SUBTITLE } from "../components/Reviews";

export default function Reviews() {
	return (
		<Page title="Reviews" subtitle={REVIEWS_SUBTITLE}>
			<ReviewsSection showHeader={false} />
		</Page>
	);
}
